import React, { useContext } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { Link } from "@mui/material";
import { NormalText } from "../../../../components/TextParts";
import { dashboardContext } from "../../Dashboard";
import { Link as RouterLink } from "react-router-dom";

export default function Notification() {
  const { notification = [] } = useContext(dashboardContext);

  return (
    <Grid container>
      <Grid item xs={12}>
        {notification.map((data, index) => (
          <Box key={data.id || index} sx={{ display: "flex", gap: "20px", pb: "20px" }}>
            <Box
              sx={{
                width: "80px",
                height: "22px",
                flexShrink: 0,
              }}
            >
              <NormalText text={data.created_at?.substring(0, 10) || ""} />
            </Box>

            <Box
              sx={{
                display: "inline-block",
                width: "80px",
                backgroundColor: "#d4d6df",
                height: "22px",
                borderRadius: 1,
                textAlign: "center",
                flexShrink: 0,
              }}
            >
              <NormalText text={data.condition || ""} />
            </Box>
            <NormalText text={data.note || ""} />
          </Box>
        ))}
      </Grid>
      <Link component={RouterLink} to="/dashboard/notification">
        過去のお知らせはこちら
      </Link>
    </Grid>
  );
}